/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkDeleteCalendarEntryDto } from '../models/work-delete-calendar-entry-dto';
import { WorkIsAvailableDto } from '../models/work-is-available-dto';
import { WorkRemoveAttendeeDto } from '../models/work-remove-attendee-dto';

@Injectable({ providedIn: 'root' })
export class WorkGoogleCalendarApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `googleCalendarApiV1ControllerOnEventUpdate()` */
  static readonly GoogleCalendarApiV1ControllerOnEventUpdatePath = '/v1/google-calendar-api/onEventUpdate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `googleCalendarApiV1ControllerOnEventUpdate()` instead.
   *
   * This method doesn't expect any request body.
   */
  googleCalendarApiV1ControllerOnEventUpdate$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkGoogleCalendarApiService.GoogleCalendarApiV1ControllerOnEventUpdatePath, 'post');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `googleCalendarApiV1ControllerOnEventUpdate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  googleCalendarApiV1ControllerOnEventUpdate(
    params?: {
    },
    context?: HttpContext
  ): Observable<void> {
    return this.googleCalendarApiV1ControllerOnEventUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `googleCalendarApiV1ControllerIsUserAvailable()` */
  static readonly GoogleCalendarApiV1ControllerIsUserAvailablePath = '/v1/google-calendar-api/isUserAvailable';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `googleCalendarApiV1ControllerIsUserAvailable()` instead.
   *
   * This method doesn't expect any request body.
   */
  googleCalendarApiV1ControllerIsUserAvailable$Response(
    params: {
      userId: number;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkIsAvailableDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkGoogleCalendarApiService.GoogleCalendarApiV1ControllerIsUserAvailablePath, 'get');
    if (params) {
      rb.query('userId', params.userId, {});
      rb.header('x-api-key', params['x-api-key'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkIsAvailableDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `googleCalendarApiV1ControllerIsUserAvailable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  googleCalendarApiV1ControllerIsUserAvailable(
    params: {
      userId: number;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<WorkIsAvailableDto> {
    return this.googleCalendarApiV1ControllerIsUserAvailable$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkIsAvailableDto>): WorkIsAvailableDto => r.body)
    );
  }

  /** Path part for operation `googleCalendarApiV1ControllerDeleteCalendarEntry()` */
  static readonly GoogleCalendarApiV1ControllerDeleteCalendarEntryPath = '/v1/google-calendar-api/deleteCalendarEntry';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `googleCalendarApiV1ControllerDeleteCalendarEntry()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  googleCalendarApiV1ControllerDeleteCalendarEntry$Response(
    params: {

    /**
     * This request requires a valid API secret.
     */
      'x-api-secret'?: string;
      body: WorkDeleteCalendarEntryDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkIsAvailableDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkGoogleCalendarApiService.GoogleCalendarApiV1ControllerDeleteCalendarEntryPath, 'post');
    if (params) {
      rb.header('x-api-secret', params['x-api-secret'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkIsAvailableDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `googleCalendarApiV1ControllerDeleteCalendarEntry$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  googleCalendarApiV1ControllerDeleteCalendarEntry(
    params: {

    /**
     * This request requires a valid API secret.
     */
      'x-api-secret'?: string;
      body: WorkDeleteCalendarEntryDto
    },
    context?: HttpContext
  ): Observable<WorkIsAvailableDto> {
    return this.googleCalendarApiV1ControllerDeleteCalendarEntry$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkIsAvailableDto>): WorkIsAvailableDto => r.body)
    );
  }

  /** Path part for operation `googleCalendarApiV1ControllerRemoveAttendee()` */
  static readonly GoogleCalendarApiV1ControllerRemoveAttendeePath = '/v1/google-calendar-api/removeAttendee';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `googleCalendarApiV1ControllerRemoveAttendee()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  googleCalendarApiV1ControllerRemoveAttendee$Response(
    params: {

    /**
     * This request requires a valid API secret.
     */
      'x-api-secret'?: string;
      body: WorkRemoveAttendeeDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkIsAvailableDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkGoogleCalendarApiService.GoogleCalendarApiV1ControllerRemoveAttendeePath, 'post');
    if (params) {
      rb.header('x-api-secret', params['x-api-secret'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkIsAvailableDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `googleCalendarApiV1ControllerRemoveAttendee$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  googleCalendarApiV1ControllerRemoveAttendee(
    params: {

    /**
     * This request requires a valid API secret.
     */
      'x-api-secret'?: string;
      body: WorkRemoveAttendeeDto
    },
    context?: HttpContext
  ): Observable<WorkIsAvailableDto> {
    return this.googleCalendarApiV1ControllerRemoveAttendee$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkIsAvailableDto>): WorkIsAvailableDto => r.body)
    );
  }

}
